import React from 'react';
import styles from './Employees.module.css';
import lalit from '../../../Assets/Employees/Director_processed.png';
import sharayu from '../../../Assets/Employees/Sharayu.png';
import Akshay from '../../../Assets/Employees/Akshay-bg.png';
import kavita from '../../../Assets/Employees/kavita.png';
import Manisha from '../../../Assets/Employees/Manisha.png';
import Satish from '../../../Assets/Employees/Satish.png';
import Sharad from '../../../Assets/Employees/Sharad.png';
import Sunil from '../../../Assets/Employees/Sunil.png';
import Aditya from '../../../Assets/Employees/aditya.png'
import Aniket from '../../../Assets/Employees/Aniket.png'
import shivraj from '../../../Assets/Employees/shivraj.jpeg'
import ishwari from '../../../Assets/Employees/ishwari.jpeg'
import kanchan from '../../../Assets/Employees/kanchan.jpeg'
import shalini from '../../../Assets/Employees/shalini.jpeg'

const directors = [
  { name: 'Lalit Kedare', image: lalit, position: 'Founder & Lead Business', dept: 'Leadership' },
  { name: 'Sharayu Kedare', image: sharayu, position: 'Director', dept: 'Leadership' },
];

const team = [
  { name: 'Kavita Jagtap', image: kavita, position: 'Head of Digital', dept: 'Digital' },
  // { name: 'Sunil Patil', image: Sunil, position: 'Director — Business & Ops', dept: 'Operations' },
  { name: 'Satish Gejage', image: Satish, position: 'Event & Production Head', dept: 'Events' },
  // { name: 'Aniket Dhebe ', image: Aniket, position: 'Opration head', dept: 'Operations' },
  // { name: 'Sharad Chavhan', image: Sharad, position: 'Operations Head', dept: 'Operations' },
  // { name: 'Manisha Bhagat', image: Manisha, position: 'Content Creator', dept: 'Creative' },
  { name: 'Akshay Gaikwad', image: Akshay, position: '3D Animator / Video Editor', dept: 'Creative' },
  // { name: 'Aditya Patil', image: Aditya, position: 'BDO', dept: 'Operations' },

  // {name: 'Shivraj Aher', image: shivraj, position: 'BDO', dept: 'Operations'},
  {name: 'Ishwari Sawant', image: ishwari, position: 'BDO', dept: 'Operations'},
  {name: 'Kanchan Sawant', image: kanchan, position: 'BDO', dept: 'Operations'},
  // {name: 'Shalini Kamble', image: shalini, position: 'Operations Head', dept: 'Operations'},

  
];

const TeamCard = ({ member }) => (
  <div className={styles.team_card}>
    <div className={styles.photo_wrap}>
      <img
        src={member.image}
        alt={`${member.name} — ${member.position} at Yeskondo Media Pune`}
        className={styles.photo}
        loading="lazy"
      />
      <span className={styles.dept_tag}>{member.dept}</span>
    </div>
    <div className={styles.card_body}>
      <div className={styles.orange_bar}></div>
      <h3 className={styles.member_name}>{member.name}</h3>
      <p className={styles.member_role}>{member.position}</p>
    </div>
  </div>
);

const Employees = () => {
  return (
    <section className={styles.employees} aria-label="Our Expert Team">

      {/* Header */}
      <div className={styles.section_header}>
        <span className={styles.eyebrow}>The People Behind the Work</span>
        <h2 className={styles.section_title}>
          Meet Our <span className={styles.orange_text}>Expert Team</span>
        </h2>
        <p className={styles.section_desc}>
          A passionate group of marketing professionals, creatives and strategists dedicated
          to making your brand shine across every platform in Pune and beyond.
        </p>
      </div>

      {/* Leadership Row */}
      <div className={styles.leadership_row}>
        <p className={styles.row_label}>Leadership</p>
        <div className={styles.directors_grid}>
          {directors.map((d, i) => <TeamCard key={i} member={d} />)}
        </div>
      </div>

      {/* Team Grid */}
      <div className={styles.team_section}>
        <p className={styles.row_label}>Our Team</p>
        <div className={styles.team_grid}>
          {team.map((m, i) => <TeamCard key={i} member={m} />)}
        </div>
      </div>

      {/* Footer note */}
      <div className={styles.team_note}>
        <span>🚀</span>
        <p>35+ talented professionals working across Pune & Maharashtra</p>
      </div>

    </section>
  );
};

export default Employees;
